import request from '@/util/request';

//获取小区列表
export const getOptionNode = (params, options) =>
    // request.get('/api/base/property/preferentOptionNode', Object.assign({}, options, { params }));
    request.get('/api/base/property/treeChildrenPowerNode', Object.assign({}, options, { params }));
    

//获取子节点
//id:id  节点id
//useDept: 1 固定为1
export const getTreeChildrenNode2 = (params, options) =>
    request.get('/api/base/property/treeChildrenNode2', Object.assign({}, options, { params }));

//获取字典
export const getDict = (code) => request.get('api/blade-system/dict/dictionary?code=' + code,);
//获取收费科目
export const getSubjectList = (code) => request.get('api/v4ward/fee/subject/getSubjectList?status=1');
//保存
export const save = (params, options) =>
    request.post('/api/v4ward/fund/preferent/save', params, options);
//删除
// export const remove = (ids) =>
//     request.post('/api/fund/preferent/remove?ids=' + ids);

export const remove = (ids) => {
    return request({
        url: '/api/v4ward/fund/preferent/remove?ids=' + ids,
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
    });
};
//获取列表
export const getList = (params, options) =>
    request.get('/api/v4ward/fund/preferent/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
    request.get('/api/v4ward/fund/preferent/detail', Object.assign({}, options, { params }));

export const update = (params, options) =>
    request.post('/api/v4ward/fund/preferent/update', params, options);

export const getSubjectListNew = (params, options) =>
request.get('/api/v4ward/fund/preferent/getSubjectList', Object.assign({}, options, { params }));

    